import * as yup from 'yup'

export const schema = yup.object({
    email: yup.string().required().email(),
    //.matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}\S$/gm)
    password: yup.string().required().min(3).max(18),
  }).required()

export const registerSchema = yup.object({
  name: yup.string().required(),
  email: yup.string().required().email(),
  password: yup.string().required().matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,18}\S$/gm),
  confirmPassword: yup.string().required().oneOf([yup.ref('password')])
}).required()

export const receiverSchema = yup.object({
  name: yup.string().required(),
  surname: yup.string().required(),
  email: yup.string().email(),
  company: yup.string().required(),
  address: yup.string().required(),
  city: yup.string().required(),
  phone: yup.string().required()
}).required()